import React, { Component, Fragment} from 'react'
import { GithubPicker } from 'react-color'
import { presetColorSwatches } from '../../Templates/data'
import CameraSlider from './CameraSlider';
export default class WebGLSettings extends Component {
    constructor(props) {
        super()
        this.settingsRef = React.createRef();  
        this.state = {
            background: '#fff',
            fly: '.5',
            rotate: '.5',
            orbit: '.5',
            pan: '.5',
            zoom: '.5'
        };
    }

    perceiveBrightness = ({r, g, b}) => {
        let brightness = Math.sqrt(
            (r * r * .299) + (g * g *.587) + (b * b *.114)
        );
        if (brightness > 130) {
            return true
        } else {
            return false
        }
    }

    handleChangeComplete = (color) => {
        let bright = this.perceiveBrightness(color.rgb)

        if ((!this.props.brightness && bright) || (this.props.brightness && !bright)) {
            this.props.unityContext.send(
                "Manager",
                "SetBrightness",
                bright ? 1 : 0
            )
        }

        this.props.unityContext.send(
            "Manager",
            "SetColor",
            color.hex
        );
        
        this.setState({ background: color.hex }, () => this.props.storeColor(color.hex, bright));
    };
    adjustFlySpeed = value => this.setState({ fly: value }, this.props.adjustFlySpeed(value))
    adjustRotateSpeed = value => this.setState({ rotate: value }, this.props.adjustRotateSpeed(value))
    adjustOrbit = value => this.setState({orbit: value}, this.props.adjustOrbit(value))
    adjustPan = value => this.setState({ pan: value }, this.props.adjustPan(value))
    adjustZoom = value => this.setState({ zoom: value }, this.props.adjustZoom(value))

    render() {
        return <Fragment>{this.props.displayWebGLSettings ?
            <div className="model-settings-item" id={`${this.props.fromAuthor ? "author" : "decimation"}-webgl-settings-container`} ref={this.settingsRef}>
                
                    <Fragment>
                        <div className="flex-column-centered-no-display shadow model-settings-item" id="color-picker">
                            <h1>Color Settings</h1>
                            <div />
                            <GithubPicker
                                color={this.state.background}
                                triangle="hide"
                                onChange={this.handleChangeComplete}
                                onChangeComplete={this.handleChangeComplete}
                                width={this.props.fromAuthor ? "68%" : "52%"}
                                colors={presetColorSwatches}
                                className="model-settings-item"
                            />
                            <h1 className="model-settings-item">Camera Settings</h1>
                            <div className="model-settings-item" style={{ width: "100%" }}>
                                Fly Speed (Free Camera Mode)
                        <CameraSlider cb={value => this.adjustFlySpeed(value)} value={this.state.fly} />
                        Rotation Speed
                        <CameraSlider cb={value => this.adjustRotateSpeed(value)} value={this.state.rotate} />
                        Orbit Speed (Rotation)
                        <CameraSlider cb={value => this.adjustOrbit(value)} value={this.state.orbit} />
                        Pan Speed
                        <CameraSlider cb={value => this.adjustPan(value)} value={this.state.pan} />
                        Zoom Speed
                        <CameraSlider cb={value => this.adjustZoom(value)} value={this.state.zoom} />
                            </div>
                            <button id="confirmation-button"
                                className="clickable  model-settings-item"
                                onClick={() => this.setState({
                                    orbit: '.5',
                                    pan: '.5',
                                    zoom: '.5',
                                    fly: '.5',
                                    background: '#fff'
                                })}
                            >Reset To Defaults</button>
                        </div>
                    </Fragment> 
            </div>: null}
            {/* {this.props.fromAuthor && this.props.displayWebGLSettings ? 
            <div className="flex-column-centered shadow" 
                id={`${this.props.fromAuthor ? "author" : "decimation"}-webgl-additional-settings-container`} 
                ref={this.settingsRef}>
                    <h1>Additional Options</h1>
                    <button id="confirmation-button"
                        className="clickable"
                        style={{ zIndex: "2" }}
                        onClick={this.props.captureModel}
                    >Capture Model Image</button>
            </div> : null} */}
        </Fragment>
    }
}